import React, { useContext, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  getWind2Entity,
  saveWind2Entity,
  deleteWind2Entity,
  renameWind2Entity,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'
import { ErrorContext } from 'context'
import { HistoryModal, RenameModal } from 'wind2/wind2utils'

const Wind2Entity = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const { setError } = useContext(ErrorContext)

  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 300px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Entity Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Entity Id :</Label> */}
        <Input
          value={insertData.entityId}
          data-cy="entityid"
          onChange={e =>
            setInsertData({
              ...insertData,
              entityId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Entity Name :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Entity Name :</Label> */}
        <Input
          value={insertData.entityName}
          data-cy="entityname"
          onChange={e =>
            setInsertData({
              ...insertData,
              entityName: e.target.value,
            })
          }
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.entityId,
              value: e.entityId,
            }))}
            modalFor="Entity"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data

              setSpinning(true)
              renameWind2Entity(apiTargetInfo)({
                oldId,
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="ENTITY"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Entity
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title="Wind Entity"
      header={Headers}
      sortOptions={HeadersSort}
      initialSortOptions={HeadersSort}
      saveTask={saveWind2Entity}
      retrieveTask={getWind2Entity}
      deleteTask={deleteWind2Entity}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={850}
      // heightOffset={100}
    />
  )
}

export default Wind2Entity

const Headers = [
  strCol({
    ident: 'entityId',
    display: 'Entity Id',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'entityName',
    display: 'Entity Name',
    isRequired: true,
    width: 250,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]

const HeadersSort = [
  strCol({
    ident: 'entityName',
    display: 'Entity Name',
    isRequired: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'entityId',
    display: 'Entity Id',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
]
